/**
 * Service to manage multiple YouTube channels and content formats.
 */

export interface YouTubeChannel {
  id: string;
  title: string;
  thumbnail: string;
  stats: {
    subscriberCount: number;
    totalLikes: number;
    totalVideos: number;
    totalShorts: number;
    totalPolls: number;
    totalComments: number;
  };
}

export interface ChannelTrend {
  date: string;
  subscribers: number;
  likes: number;
}

export const dummyChannels: YouTubeChannel[] = [
  {
    id: "ch1",
    title: "Code Master",
    thumbnail: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=100&q=80",
    stats: {
      subscriberCount: 12500,
      totalLikes: 45000,
      totalVideos: 120,
      totalShorts: 45,
      totalPolls: 12,
      totalComments: 3400
    }
  },
  {
    id: "ch2",
    title: "Daily Vlogs",
    thumbnail: "https://images.unsplash.com/photo-1516259762381-22954d7d3ad2?w=100&q=80",
    stats: {
      subscriberCount: 840,
      totalLikes: 2100,
      totalVideos: 15,
      totalShorts: 30,
      totalPolls: 5,
      totalComments: 120
    }
  }
];

export const getChannelTrends = (channelId: string): ChannelTrend[] => {
  // Mock trend data for the last 7 days
  const baseSubs = channelId === "ch1" ? 12000 : 800;
  const baseLikes = channelId === "ch1" ? 40000 : 1500;
  
  return Array.from({ length: 7 }).map((_, i) => ({
    date: new Date(Date.now() - (6 - i) * 86400000).toLocaleDateString(),
    subscribers: baseSubs + (i * 100) + Math.floor(Math.random() * 50),
    likes: baseLikes + (i * 1000) + Math.floor(Math.random() * 200),
  }));
};
